const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.extensions;

const grpc = {};
grpc.web = require("grpc-web");
